<template>
  <v-autocomplete
      color="primary"
      bg-color="white"
      variant="underlined"
      density="compact"
      v-if="field_name === 'tags_array'"
      :label="$store.getters.translate('tags')"
      v-model="advanced_search['tags_array']"
      :return-object="false"
      item-value="name.en"
      item-title="name.en"
      :items="all_tags"
      @update:model-value="$emit('showRecords')"
      single-line
      hide-details
      multiple
      clearable/>
  <v-autocomplete
      color="primary"
      bg-color="white"
      variant="underlined"
      density="compact"
      v-else-if="field_type === 'boolean'"
      :label="$store.getters.translate(field_name)"
      v-model="advanced_search[field_name]"
      :return-object="false"
      item-value="value"
      item-title="text"
      :items="[{ value: true, text: $store.getters.translate('yes')}, { value: false, text: $store.getters.translate('no') }]"
      @update:model-value="$emit('showRecords')"
      single-line
      hide-details
      clearable/>
  <!--CAN`T SEARCH IN _NAMES (_IDS) FIELDS BECAUSE THEY ARE ARRAYS-->
  <v-text-field
      v-else-if="field_type !== 'select_multiple' && !field_name.includes('_ids') && !field_name.includes('_names') && field_name !== 'tags_array'"
      color="primary"
      variant="underlined"
      density="compact"
      v-model="advanced_search[field_name]"
      @update:model-value="$emit('showRecords')"
      @click:clear="$emit('clearSearch', field_name)"
      :label="$store.getters.translate(field_name)"
      single-line
      hide-details
      clearable/>
</template>

<script>
import {PhChatTeardropText} from "@phosphor-icons/vue";
import helpFunctions from "../../plugins/helpFunctions";

export default {
  components: {PhChatTeardropText},
  props: ["advanced_search", "field_name", "field_type"],
  data() {
    return {
      all_tags: [],
    };
  },
  created() {
    if(this.field_name === 'tags_array') {
      this.loadTags();
    }
  },
  methods: {
    async loadTags() {
      this.all_tags = await helpFunctions.getFullAdditionalModels(this.$toast, "tag");
    },
  }
};
</script>